<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

<ng-template #itemTemplate let-item="item">
  <div class="form-inline row-item">
    <i *ngIf="item.children" aria-hidden="true" class="fa" (click)="item.collapsed=!item.collapsed"
       [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input *ngIf="!item.children" type="checkbox" class="form-check-input" (change)="templateChanged()" [(ngModel)]="item.checked" />
      <!-- parent. allow to collapse-->
      <label *ngIf="item.children" class="form-check-label" (click)="item.collapsed=!item.collapsed">{{item.text}}</label>
      <!-- children. allow to check-->
      <label *ngIf="!item.children" class="form-check-label" (click)="item.checked = !item.checked;">{{item.text}}</label>
    </div>
  </div>
</ng-template>


<h1>User Migration</h1>


<form class="mt-3" role="form" novalidate #form="ngForm" method="post" (ngSubmit)="run()">
  <div class="row">
    <div class="col-md-4 col-xs-1">
      <div class="form-group input-required">
        <label for="customer">Customer</label>


        <select2 required [settings]="{placeholder: 'Not Selected',width:'100%'}" id="customer"
                 name="customer"
                 [options]="customers" [(ngModel)]="customer"
                 (onSelect)="customerChanged($event)"></select2>

      </div>

    </div>

    <div class="col-md-4 col-xs-1">


      <div class="form-group input-required">
        <label for="environment">Environment</label>

        <select2 required [settings]="{placeholder: 'Not Selected',width:'100%'}" id="environment"
                 name="environment"
                 [options]="environments" [(ngModel)]="environment"
                 (onSelect)="environmentChanged($event)"></select2>



      </div>
    </div>

    <div class="col-md-4 col-xs-1">
      <div class="form-group input-required">
        <label for="corporation">Corporation</label>

        <select2 required [settings]="{placeholder: 'Not Selected',width:'100%'}" id="corporation"
                 name="corporation"
                 [options]="corporations" [(ngModel)]="corporation"
                 (onSelect)="corporationChanged($event)"></select2>

      </div>

    </div>

  </div>


  <div class="row">
    <div class="col-md-4 col-xs-1">
      <div class="form-group ">
        <label for="facility">Facility</label>

        <ngx-bootstrap-multiselect [texts]="multiSelectSettingsTexts"
                                   [settings]="multiSelectSettings"
                                   name="facilities"
                                   [options]="facilityOptions"
                                   [(ngModel)]="facilities">
        </ngx-bootstrap-multiselect>




      </div>

    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-8 col-xs-1">

      <re-collapsible-group header="Security Templates to be excluded" [isCollapsed]="isSecurityTemplatesCollapsed">
        <ng-container>
          <div class="form-group">
            <!--<ss-multiselect-dropdown [texts]="multiSelectSettingsTexts" [settings]="multiSelectSettings" name="securityTemplates" [options]="securityTemplateOptions" [(ngModel)]="securityTemplates"></ss-multiselect-dropdown>-->
            <div class="mb-2 ml-2 font-italic">(Selected templates will be excluded from migration)</div>
            <ngx-treeview (selectedChange)="templateChanged()" id="templatesTree" [itemTemplate]="itemTemplate" [config]="treeConfig" [items]="securityTemplateOptions ">
            </ngx-treeview>

          </div>
        </ng-container>
      </re-collapsible-group>

    </div>
  </div>


  <div class="row mt-3">
    <div class="col-12">
      <button type="button" (click)="back()" class="btn btn-default">Back</button>
      <button type="submit" class="btn btn-primary" [disabled]="!form.valid">Search Users</button>
      <button type="button" class="btn btn-default mr-3" (click)="reset()">Clear Fields</button>
    </div>
  </div>



  <div [hidden]="!unfilteredData">
    <div class="row mt-5">
      <div class="col-12 form-group">
        <span class="button-container">
        </span>
        <button (click)="import()" [disabled]="unfilteredData==0 || selectedUsers.size === 0" *ngIf="isSnfLegacyImportUser" type="button" class="btn btn-primary">Import Legacy to IDM</button>
        <div class="ml-3 form-check form-check-inline">
          <input name="onlyErrors" (change)="onlyErrorsChanged($event)" [(ngModel)]="onlyErrors" class="form-check-input" id="onlyErrors" type="checkbox" value="" />
          <label class="form-check-label" for="onlyErrors">Only show users with errors</label>
        </div>

      </div>
    </div>

    <div class="row mt-3">
      <div class="col-8">
        Pre Migration readiness for users in the list bellow ({{numberOfErrors==0 ? 'no errors': numberOfErrors+' unresolved errors'}} out of {{unfilteredData?.length}} users)
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-md-8">
        <div class="progress ">
          <div class="progress-bar" *ngIf="errorPercentage!=0"
               [style.width.%]="errorPercentage"
               role="progressbar"
               aria-valuenow="{{errorPercentage}}"
               aria-valuemin="0"
               aria-valuemax="100">
            {{errorPercentage|number}}%
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" [hidden]="!unfilteredData">
    <div class="col-12">
      <table class="table table-bordered table-striped table-fit" id="resultsDataTable">
      </table>

    </div>
  </div>

</form>
